/* global __WEB__ */

import map from 'lodash/map';
import throttler from './throttler';
import {
    socketConnect,
    socketSubscribe,
    socketUnsubscribe,
} from '../actions/socket';

class RankingSubscriber {
    constructor() {
        this.allReady = false;
        this.connectionError = false;

        // Keep a reference to params we subscribe to by channel-id
        // [channel-id]: [params]
        this.channels = {};

        // Since there's potentially a lot of rows in the recieved tables,
        // we have to add them to an array to be dispatched asyncronously.
        this.data = [];

        this.hasSent = false;
    }

    start(create, update, url, dispatch) {
        this.url = url;
        this.dispatch = dispatch;

        // Create dispatch functions which is throttled, to be called maximun once per 750 ms
        // per ticker.
        this.createDispatch = throttler((...args) => {
            create(...args);
        }, 750);

        this.updateDispatch = throttler((...args) => {
            update(...args);
        }, 750);

        this.connect();
    }

    connect() {
        if (!window.WebSocket) return;

        this.dispatch(socketConnect({ url: this.url }));
    }

    onMessageHandler(data) {
        try {
            if (typeof data.type === 'undefined') {
                return;
            }

            if (data.type === 'meta' && data.values) {
                const ready = data.values.initial_data_sent || false;

                // If we get the message that all data is successfully sent,
                // we dispatch the create action with the array of ticker objects
                if (ready && typeof ready !== 'undefined') {
                    this.createDispatch(this.data);
                    this.data = [];
                }
            }

            if (data.type === 'new') {
                this.data.push({
                    key: data.key,
                    values: data.values,
                });
            }

            if (data.type === 'update') {
                this.updateDispatch(data.key, data.values);
            }
        } catch (e) {
            // ignore error
        }
    }

    subscribe(channel, params) {
        // @TODO
        // May have to implement params signature check
        // to see if we're already subscribing to it

        const {
            columns,
            expression,
            limit,
            offset,
            ranking,
            sources,
        } = params;

        const queryOptions = {
            columns: columns.join(','),
            ranking,
            channel,
        };

        if (limit && typeof limit !== 'undefined') {
            queryOptions.limit = limit;
        }

        if (offset && typeof offset !== 'undefined') {
            queryOptions.offset = offset;
        }

        // If the sources param is an array we must use generators
        // to pass the source for the API, orherwise we simply use
        // source to pass it.
        if (Array.isArray(sources) && sources.length > 1) {
            sources.forEach((source, i) => {
                const key = `generators[${i}][source]`;

                queryOptions[key] = `${source} as source`;
            });
        } else if (Array.isArray(sources)) {
            queryOptions.source = sources[0];
        } else {
            queryOptions.source = sources;
        }

        // If an expression is passed as a parameter, we'll have to
        // add some additional parameters to the query to handle this.
        if (expression) {
            queryOptions.expression = expression;
            queryOptions.convert = 'expression';
            queryOptions.cutoffAtZero = true;
        }

        // Format the query as a URL that can be passed to the message
        const query = map(queryOptions, (value, key) => `${key}=${value}`).join('&');

        // Store a reference to the channel. So we can re-subscribe if we lose connection.
        this.channels[channel] = params;

        // Send the subscription message
        this.dispatch(socketSubscribe({
            channel,
            query,
            onMessage: this.onMessageHandler.bind(this),
        }));

        return channel;
    }

    unsubscribe(channel) {
        if (!channel) {
            return;
        }

        this.dispatch(socketUnsubscribe({ channel }));
    }
}

export default __WEB__ ? new RankingSubscriber() : null;



/** WEBPACK FOOTER **
 ** /src/shared/service/RankingSubscriber.js
 **/